export const landingStrings = {
  tagline: 'One calm place for the hobbies, plans, and personal collections that make up your life.',
  highlightsLabel: 'Hobtalk highlights',
  highlights: {
    track: {
      title: 'Track what you love',
      detail: 'Recipes, movies, shows, books, trips, workouts, and hikes in focused spaces.',
    },
    recommendations: {
      title: 'Personal recommendations',
      detail: 'Get useful ideas based on what you save, finish, rate, and revisit.',
    },
    insights: {
      title: 'Insights over time',
      detail: 'See patterns in what you watch, read, cook, plan, and log.',
    },
  },
  auth: {
    opening: 'Opening sign-in...',
    signInOrCreate: 'Continue with Hobtalk',
    privateBeta: 'Access is limited while Hobtalk is in private beta.',
  },
};
